import React, {Suspense} from 'react';
import {TripBoardsModalReduxProvider} from '@homeaway/react-trip-board-button';
import Experiment from '@homeaway/react-experiment';
import {HA_IDA_LOGIN_TO_SAVE_TRIPBOARD} from '../../abacus/experiments';

const LoginExperience = React.lazy(
    /* istanbul ignore next */ () =>
        import(/* webpackChunkName: "react-lex" */ '@homeaway/react-lex')
);

export default function TripBoardsProviderContainer({
    siteName,
    isLoggedIn,
    locale,
    brand,
    graphqlQuery,
    adultsCount,
    childrenCount,
    endDate,
    petIncluded,
    startDate
}) {
    const tripBoardProviderParams = {
        graphqlQuery,
        adultsCount,
        childrenCount,
        endDate,
        petIncluded,
        startDate
    };

    return isLoggedIn ? (
        <TripBoardsModalReduxProvider
            siteName={siteName}
            {...tripBoardProviderParams}
            isLoggedIn={isLoggedIn}
            autosave
        />
    ) : (
        <Experiment name={HA_IDA_LOGIN_TO_SAVE_TRIPBOARD} deferLogging>
            {({On, Off}) => (
                <React.Fragment>
                    <On>
                        <TripBoardsModalReduxProvider
                            siteName={siteName}
                            {...tripBoardProviderParams}
                            isLoggedIn={isLoggedIn}
                            autosave
                            renderInitialModal={(onComplete, onClose, isOpen) => {
                                return (
                                    isOpen && (
                                        <Suspense fallback={null}>
                                            <LoginExperience
                                                modalMode
                                                locale={locale}
                                                actionLocation="heartButtonLogin"
                                                site={siteName}
                                                siteName={brand}
                                                handleCloseModal={onClose}
                                                handleLoginSuccess={onComplete}
                                                configContext="savetripboard"
                                            />
                                        </Suspense>
                                    )
                                );
                            }}
                        />
                    </On>
                    <Off>
                        <TripBoardsModalReduxProvider
                            siteName={siteName}
                            {...tripBoardProviderParams}
                            isLoggedIn={isLoggedIn}
                            autosave
                        />
                    </Off>
                </React.Fragment>
            )}
        </Experiment>
    );
}
